import axios from "axios";

export function apiGetLocalisations(instance, queryParams) {
  return axios
    .get(
      process.env.REACT_APP_URL_EXPRESS +
        "api/localisations" +
        (queryParams ? "?" + queryParams : ""),
      {
        headers: {
          instance: instance,
        },
      }
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiGetLocalisation(instance, id, queryParams) {
  return axios
    .get(
      process.env.REACT_APP_URL_EXPRESS +
        "api/localisations/" +
        id +
        (queryParams ? "?" + queryParams : ""),
      {
        headers: {
          instance: instance,
        },
      }
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiSaveLocalisation(instance, formData) {
  return axios
    .post(process.env.REACT_APP_URL_EXPRESS + "api/localisations", formData, {
      headers: {
        instance: instance,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiUpdateLocalisation(id, formData) {
  return axios
    .put(process.env.REACT_APP_URL_EXPRESS + "api/localisations/" + id, formData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiDeleteLocalisation(id) {
  return axios
    .delete(process.env.REACT_APP_URL_EXPRESS + "api/localisations/" + id)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiDecodeLatLng(adresse) {
  return axios
    .get("https://api-adresse.data.gouv.fr/search/?q=" + adresse)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}
